const FLAG_KEY = 'tanstack_router_shell'

/**
 * Pre-mount toggle for the TanStack Router coexistence shell.
 *
 * Read synchronously before render: the account/partner feature toggles that
 * normally gate a feature only load after the app boots — inside the very router
 * this decides. So the shell reads two sources that exist before mount. URL param
 * wins (a one-off QA flip), then localStorage (sticky per browser). A
 * server-bootstrapped percentage ramp is the production follow-up; both sources
 * here let a tester flip the shell on staging without a redeploy.
 */
export function isTanstackShellEnabled(): boolean {
  if (typeof window === 'undefined') return false

  try {
    const param = new URLSearchParams(window.location.search).get(FLAG_KEY)
    if (param === '1' || param === 'true') return true
    if (param === '0' || param === 'false') return false

    return window.localStorage.getItem(FLAG_KEY) === '1'
  } catch {
    return false
  }
}
